$(function () {
	/* クッキーをセットする
	 -------------------------------------------------- */
	function setSiteviewCookie() {
		$('.c-lang-change button').bind('click', function () {　//言語切り替えボタンを押下したときに発火
			$.cookie('siteview', $(this).data('siteview'), { path: '/' }); //siteviewという名前でcookieに値をセット
		});

		// 初期設定
		$('.c-lang-change button.jp').addClass('selected');
		$('.content-en').css('display', 'none');
		$('.content-chi').css('display', 'none');

		//日本語の時
		$('.c-lang-change button.jp').bind('click', function () {
			$('.content-jp').css('display', 'block');
			$('.content-en').css('display', 'none');
			$('.content-chi').css('display', 'none');
			$('.c-lang-change button').removeClass('selected');
			$('.c-lang-change button.jp').toggleClass('selected');
		});

		//英語の時
		$('.c-lang-change button.en').bind('click', function () {
			$('.content-en').css('display', 'block');
			$('.content-jp').css('display', 'none');
			$('.content-chi').css('display', 'none');
			$('.c-lang-change button').removeClass('selected');
			$('.c-lang-change button.en').toggleClass('selected');
		});

		//中国語の時
		$('.c-lang-change button.chi').bind('click', function () {
			$('.content-chi').css('display', 'block');
			$('.content-en').css('display', 'none');
			$('.content-jp').css('display', 'none');
			$('.c-lang-change button').removeClass('selected');
			$('.c-lang-change button.chi').toggleClass('selected');
		});


	}
	setSiteviewCookie();

	//日本語の時
	if ($.cookie('siteview') == 'jp') {
		$('.content-jp').css('display', 'block');
		$('.content-en').css('display', 'none');
		$('.content-chi').css('display', 'none');
		$('.c-lang-change button').removeClass('selected');
		$('.c-lang-change button.jp').addClass('selected');
	}

	//英語の時
	if ($.cookie('siteview') == 'en') {
		$('.content-en').css('display', 'block');
		$('.content-jp').css('display', 'none');
		$('.content-chi').css('display', 'none');
		$('.c-lang-change button').removeClass('selected');
		$('.c-lang-change button.en').toggleClass('selected');
	}
	//中国語の時
	if ($.cookie('siteview') == 'chi') {
		$('.content-chi').css('display', 'block');
		$('.content-en').css('display', 'none');
		$('.content-jp').css('display', 'none');
		$('.c-lang-change button').removeClass('selected');
		$('.c-lang-change button.chi').toggleClass('selected');
	}

});
